import React, { Component } from 'react';
import '../css/styleHome.css';
import { Col, Row, Label, FormGroup, Button, Input, Card, CardBody, Progress } from 'reactstrap';
import HeaderComp from "../components/HeaderAgenteLogin"
import fondo from "../imgs/KLBackground.png"
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { validarArea, sesionArea, obtenerAreas } from "../actions/index";
import MensajeModal from "../components/MensajeModal"
import { Redirect } from 'react-router-dom';
import { OBTENER_URL_FRONTEND } from "../constants/action-types";

const mapStateToProps = state => {
    return {
        respuestaArea: state.respuestaArea,
        areas: state.areas
    };
};

const mapDispatchToProps = dispatch => {
    return {
        ...bindActionCreators({ validarArea, sesionArea, obtenerAreas }, dispatch)
    };
};

class LoginAgentes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalEstado: false,
            modalTitulo: "",
            modalMensaje: "",
            modalFooter: "",
            validacion: false,
            password: "",
            seleccionID: "1",
            seleccionNombre: "",
        };
        this.toggle = this.toggle.bind(this);
        this.modalAyuda = this.modalAyuda.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.buscarArea = this.buscarArea.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.abrirColas = this.abrirColas.bind(this);
    }


    modalAyuda() {
        this.setState({
            modalTitulo: "Ayuda",
            modalMensaje:
                <div>
                    <p>Este es el inicio de sesión para los Agentes que atenderán los servicios solicitados por los usuarios del Sistema de Gestión de Turnos.</p>
                    <p>Para continuar, haz click en el botón: "Inicia sesión con tu cuenta institucional" y serás redirigido al inicio de sesión seguro de Outlook.</p>
                    <p></p>
                    <p>Si tienes problemas, alguna queja o duda sobre el funcionamiento, comunicate al:</p>
                    <p>(+57-1) 347 2311 ext. 186 (Departamento de TI)</p>
                    <p></p>
                    <p>En el Departamento de TI de la universidad estamos atentos a tus sugerencias, recomendaciones o problemas durante este proceso.</p>
                </div>,
            modalFooter: <Button onClick={this.toggle}> Cerrar</Button>
        })
        this.toggle();
    }

    toggle() {
        this.setState({
            modalEstado: !this.state.modalEstado
        });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.respuestaArea.tipo !== undefined && nextProps.respuestaArea.tipo != {} && nextProps.respuestaArea.tipo !== null && nextProps.respuestaArea.tipo !== "") {
            setTimeout(
                function () {
                    //console.log(nextProps.respuestaArea)
                    if (nextProps.respuestaArea.tipo === "ERROR") {
                        this.setState({
                            modalTitulo: "ERROR",
                            modalMensaje:
                                <div>
                                    <center>
                                        <p>Inicio de sesión fallido.</p>
                                        <p>La contraseña ingresada no coincide con el área.</p>
                                    </center>
                                </div>,
                            modalFooter: <Button onClick={this.toggle}> Cerrar</Button>,
                        })
                        //this.toggle();
                    } else {
                        var area = {
                            idArea: this.state.seleccionID,
                            nombreArea: this.state.seleccionNombre,
                        }
                        window.open(OBTENER_URL_FRONTEND + "/pantalla/" + this.state.seleccionID, "_blank")
                        this.props.sesionArea(area);
                        setTimeout(
                            function () {
                                this.datosConfirmados();
                            }
                                .bind(this),
                            10
                        );
                    }
                }
                    .bind(this),
                10
            );
        }
    }

    buscarArea() {
        this.setState({
            modalTitulo: "Cargando",
            modalMensaje:
                <div>
                    <center>
                        <p>Validando datos, por favor espera.</p>
                    </center>
                </div>,
            modalFooter: <div style={{ width: "100%" }}>
                <Progress animated color="success" value="100" />
            </div>,
        })
        this.toggle();
        var envio = [];
        envio[0] = this.state.seleccionID;
        envio[1] = this.state.password;
        this.props.validarArea(envio);
    }

    abrirColas() {
        window.open(OBTENER_URL_FRONTEND + "/pantalla/" + this.state.seleccionID, "_blank");
    }

    datosConfirmados() {
        this.setState({ validacion: true })
    }

    componentDidMount() {
        document.title = "DigiturnoKL - Login Módulo";
        this.props.obtenerAreas();
    }

    handleChange(event) {
        var selector = document.getElementById("selectArea");
        var value = selector[selector.selectedIndex].value;
        var name = selector[selector.selectedIndex].id;
        this.setState({
            [event.target.name]: event.target.value,
            seleccionID: value,
            seleccionNombre: name,
        })
    }

    handleSelect(event) {
        this.setState({ seleccionID: event.target.value })
    }

    render() {
        if (this.state.validacion === true) {
            return <Redirect to={{ pathname: '/Usuario/Home' }} />
        }

        var opcionesAreas = this.props.areas.map(p => {
            return (<option key={p[0]} value={p[0]} id={p[1]}>{p[1]} </option>)
        });

        var botonIngresar
        if (this.state.password === "") {
            botonIngresar = <Button color="success" id="botonIngresar" disabled>Ingresar</Button>;
        }
        else {
            botonIngresar = <Button color="success" onClick={this.buscarArea} id="botonIngresar">Ingresar</Button>
        }
        return (
            <div>
                <MensajeModal modal={this.state.modalEstado} titulo={this.state.modalTitulo} toggle={this.toggle} mensaje={this.state.modalMensaje} footer={this.state.modalFooter} ></MensajeModal>
                <div id="home">
                    <div className="bg-img" style={{ backgroundImage: "url(" + fondo + ")" }}>
                        <div className="overlay"></div>
                    </div>
                    <div className="home-wrapper">
                        <div className="container">
                            <Row>
                                <Col xs="12">
                                    <div className="home-content">
                                        <HeaderComp></HeaderComp>
                                        <Col xs="12">
                                            <Row>
                                                <Col xs="1" sm="2" md="3"></Col>
                                                <Col xs="10" sm="8" md="6">
                                                    <center>
                                                        <FormGroup>
                                                            <Label cfor="exampleEmail"><h3>Sistema de Gestión de Turnos</h3></Label>
                                                            <Label cfor="exampleEmail"><h3>Inicio de sesión de Módulos</h3></Label>
                                                        </FormGroup>
                                                        <Card>
                                                            <CardBody>

                                                                <FormGroup>
                                                                    <Label for="exampleSelect">Selecciona el área</Label>
                                                                    <Input onChange={this.handleSelect} type="select" name="select" id="selectArea">
                                                                        {opcionesAreas}
                                                                    </Input>
                                                                </FormGroup>
                                                                <FormGroup>
                                                                    <Label for="examplePassword">Ingresa la contraseña del área seleccionada</Label>
                                                                    <Input onChange={this.handleChange} value={this.state.password} type="password" name="password" id="passwordArea" />
                                                                </FormGroup>

                                                                {botonIngresar}
                                                                <br />
                                                                <Button color="info" onClick={this.abrirColas} size="sm">Abrir cola del área seleccionada</Button>
                                                                <br />
                                                                <Button color="info" onClick={this.modalAyuda} size="sm">ayuda</Button>

                                                            </CardBody>
                                                        </Card>
                                                    </center>
                                                </Col>
                                                <Col xs="1" sm="2" md="3"></Col>
                                            </Row>
                                        </Col>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(LoginAgentes);